import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { hideDialog } from '../../../base/dialog/actions';
import { translate } from '../../../base/i18n/functions';
import Dialog from '../../../base/ui/components/web/Dialog';
import { setAudioTranslationLanguage, setParticipantAudioTranslationLanguage } from '../../actions';
import { SUPPORTED_TRANSLATION_LANGUAGES } from '../../constants';
import AudioTranslationLanguageItem from './AudioTranslationLanguageItem';
const useStyles = makeStyles()(() => {
    return {
        list: {
            display: 'flex',
            flexDirection: 'column'
        }
    };
});
/**
 * A dialog for selecting the AI audio-translation target language (or off).
 *
 * @param {IProps} props - The component's props.
 * @returns {ReactElement}
 */
const AudioTranslationDialog = ({ participantId, t }) => {
    const dispatch = useDispatch();
    const { classes: styles } = useStyles();
    const defaultLanguage = useSelector((state) => state['features/audio-translation'].language);
    const participantLanguages = useSelector((state) => state['features/audio-translation'].participantLanguages);
    // Highlight the effective language for the target: the per-participant override if one is set, else the
    // default. (For the conference-wide dialog there is no participantId, so this is just the default.)
    const language = participantId && participantId in participantLanguages
        ? participantLanguages[participantId]
        : defaultLanguage;
    const onSelect = useCallback((code) => {
        if (participantId) {
            dispatch(setParticipantAudioTranslationLanguage(participantId, code));
        }
        else {
            dispatch(setAudioTranslationLanguage(code));
        }
        dispatch(hideDialog());
    }, [dispatch, participantId]);
    return (React.createElement(Dialog, { cancel: { hidden: true }, ok: { hidden: true }, titleKey: 'toolbar.audioTranslation' },
        React.createElement("div", { className: styles.list },
            React.createElement(AudioTranslationLanguageItem, { code: null, label: t('toolbar.audioTranslationOff'), onSelect: onSelect, selected: !language }),
            SUPPORTED_TRANSLATION_LANGUAGES.map(({ code, label }) => (React.createElement(AudioTranslationLanguageItem, { code: code, key: code, label: label, onSelect: onSelect, selected: language === code }))))));
};
export default translate(AudioTranslationDialog);
